// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumbs-con {
  height: 100%;
}
.breadcrumbs-con .breadcrumbs-col {
  display: flex;
}

.breadcrumbs-con .breadcrumb {
  margin-bottom: 0 !important;
}

.breadcrumb ol {
  margin-bottom: 0 !important;
}

.breadcrumb-typo-bold {
  font-size: 20px;
  font-weight: 600;
  line-height: 26px;
  color: #000;
  font-family: "Poppins";
}

.breadcrumb-max-width {
  max-width: 500px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 1600px) {
  .breadcrumb-max-width {
    max-width: 450px;
  }
}
@media (max-width: 1400px) {
  .breadcrumb-max-width {
    max-width: 400px;
  }
}
@media (max-width: 1200px) {
  .breadcrumb-max-width {
    max-width: 300px;
  }
}
@media (max-width: 1024px) {
  .breadcrumb-max-width {
    max-width: 250px;
  }
}
@media (max-width: 900px) {
  .breadcrumb-max-width {
    max-width: 200px;
  }
}
@media (max-width: 768px) {
  .breadcrumb-max-width {
    max-width: 150px;
  }
}
@media (max-width: 600px) {
  .breadcrumb-max-width {
    max-width: 120px;
  }
}
@media (max-width: 480px) {
  .breadcrumb-max-width {
    max-width: 100px;
  }
}
@media (max-width: 360px) {
  .breadcrumb-max-width {
    max-width: 80px;
  }
}
@media (max-width: 320px) {
  .breadcrumb-max-width {
    max-width: 70px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Common/Breadcrumb.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;AAAI;EACI,aAAA;AAER;;AAEA;EACI,2BAAA;AACJ;;AAEA;EACI,2BAAA;AACJ;;AAEA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACJ;;AAEA;EACI;IACI,gBAAA;EACN;AACF;AAEA;EACI;IACI,gBAAA;EAAN;AACF;AAGA;EACI;IACI,gBAAA;EADN;AACF;AAIA;EACI;IACI,gBAAA;EAFN;AACF;AAKA;EACI;IACI,gBAAA;EAHN;AACF;AAMA;EACI;IACI,gBAAA;EAJN;AACF;AAOA;EACI;IACI,gBAAA;EALN;AACF;AAQA;EACI;IACI,gBAAA;EANN;AACF;AASA;EACI;IACI,eAAA;EAPN;AACF;AAUA;EACI;IACI,eAAA;EARN;AACF","sourcesContent":[".breadcrumbs-con {\n    height: 100%;\n    .breadcrumbs-col {\n        display: flex;\n    }\n}\n\n.breadcrumbs-con .breadcrumb {\n    margin-bottom: 0 !important;\n}\n\n.breadcrumb ol {\n    margin-bottom: 0 !important;\n}\n\n.breadcrumb-typo-bold {\n    font-size: 20px;\n    font-weight: 600;\n    line-height: 26px;\n    color: #000;\n    font-family: \"Poppins\";\n}\n\n.breadcrumb-max-width {\n    max-width: 500px; // Default for extra-large screens\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n@media (max-width: 1600px) {\n    .breadcrumb-max-width {\n        max-width: 450px; // Large desktops\n    }\n}\n\n@media (max-width: 1400px) {\n    .breadcrumb-max-width {\n        max-width: 400px; // Medium-large desktops\n    }\n}\n\n@media (max-width: 1200px) {\n    .breadcrumb-max-width {\n        max-width: 300px; // Standard desktops\n    }\n}\n\n@media (max-width: 1024px) {\n    .breadcrumb-max-width {\n        max-width: 250px; // Large tablets, small laptops\n    }\n}\n\n@media (max-width: 900px) {\n    .breadcrumb-max-width {\n        max-width: 200px; // Tablets and small laptops\n    }\n}\n\n@media (max-width: 768px) {\n    .breadcrumb-max-width {\n        max-width: 150px; // Tablets in portrait mode\n    }\n}\n\n@media (max-width: 600px) {\n    .breadcrumb-max-width {\n        max-width: 120px; // Large mobile devices, phablets\n    }\n}\n\n@media (max-width: 480px) {\n    .breadcrumb-max-width {\n        max-width: 100px; // Standard mobile devices\n    }\n}\n\n@media (max-width: 360px) {\n    .breadcrumb-max-width {\n        max-width: 80px; // Small mobile devices\n    }\n}\n\n@media (max-width: 320px) {\n    .breadcrumb-max-width {\n        max-width: 70px; // Extra small mobile devices\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
